import { useMutation } from "@tanstack/react-query";
import { getShortlistPreviewHtml } from "../api/shortlist-report-api";
import type { ShortlistPreviewHtmlResponse, ShortlistPreviewHtmlParams } from "../api/shortlist-report-api";

export const useShortlistPreviewHtml = () => {
	return useMutation<ShortlistPreviewHtmlResponse, Error, ShortlistPreviewHtmlParams>({
		mutationFn: getShortlistPreviewHtml,
	});
};
